import VectorTileLayer from 'ol/layer/VectorTile'
import { applyStyle } from 'ol-mapbox-style'
import { getStandardLayerProps } from './utils'

export function createVectorTileLayer(config) {
  const layer = new VectorTileLayer({
    ...getStandardLayerProps(config),
  })

  switch (config.type) {
    case 'mapboxStyle':
      applyStyle(
        layer,
        config.url,
      ).catch((err) => {
        console.error('Error applying vector style:', err)
      })
      break
  }

  return layer
}
